var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInputDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5298 60.0662C66.6984 60.0662 76.5629 50.2017 76.5629 38.0331C76.5629 25.8646 66.6984 16 54.5298 16C42.3613 16 32.4967 25.8646 32.4967 38.0331C32.4967 50.2017 42.3613 60.0662 54.5298 60.0662ZM54.5298 63.0662C68.3552 63.0662 79.5629 51.8585 79.5629 38.0331C79.5629 24.2077 68.3552 13 54.5298 13C40.7044 13 29.4967 24.2077 29.4967 38.0331C29.4967 51.8585 40.7044 63.0662 54.5298 63.0662Z",
    fill: "#404d54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.1258 63.3741C33.2411 63.3741 15.5 81.1152 15.5 103H12.5C12.5 79.4584 31.5842 60.3741 55.1258 60.3741C78.6674 60.3741 97.7517 79.4584 97.7517 103H94.7517C94.7517 81.1152 77.0106 63.3741 55.1258 63.3741Z",
    fill: "#404d54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.364 17.5762H79.5232V15.5762H103.364V17.5762Z",
    fill: "#FFE173"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.364 23.5364H79.5232V21.5364H103.364V23.5364Z",
    fill: "#FFE173"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8278 29.4967H79.5232V27.4967H93.8278V29.4967Z",
    fill: "#FFE173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInputDark);
export default __webpack_public_path__ + "static/media/user-input-dark.103c23b96ad120945bce9c0b0dc350be.svg";
export { ForwardRef as ReactComponent };